import { render, staticRenderFns } from "./CreatorCommentStatistics.vue?vue&type=template&id=5c927ce9&scoped=true&"
import script from "./CreatorCommentStatistics.vue?vue&type=script&lang=js&"
export * from "./CreatorCommentStatistics.vue?vue&type=script&lang=js&"
import style0 from "./CreatorCommentStatistics.vue?vue&type=style&index=0&id=5c927ce9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c927ce9",
  null
  
)

export default component.exports